import React from 'react';
import { Offline } from 'react-detect-offline';
//
import Spin from 'antd/lib/spin';
import Icon from 'antd/lib/icon';

const s = {
  container: {
    zIndex: 10000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(64, 64, 64, 0.48)',
  },
};

class OfflinePlaceholder extends React.PureComponent {
  render() {
    return (
      <Offline>
        <div style={s.container}>
          <div style={{ textAlign: 'center' }}>
            <Spin
              size="large"
              indicator={(
                <Icon
                  type="loading"
                  style={{ marginBottom: 15, fontSize: 34, color: '#fff' }}
                  spin
                />
              )}
            />
            <h1 style={{ color: '#fff', fontWeight: 600 }}>Offline</h1>
            <h3 style={{ marginTop: 2, color: '#fff', fontWeight: 600 }}>
              Your internet seems too slow to reach our servers
            </h3>
          </div>
        </div>
      </Offline>
    );
  }
}

export default OfflinePlaceholder;



// WEBPACK FOOTER //
// ./src/components/common/OfflinePlaceholder/index.js